import './PositionsListSkeleton.scss';

const PositionsListSkeleton = () => {

    return (
        <div className="pos__list__section__skeleton">
            <div className="pos__list__item__skeleton">
                {[...Array(3)].map((_, index) => (
                    <div key={index} className="pos__list__question__skeleton">
                        <div className='pos__list__title__skeleton'></div>
                        <span className="pos__list__arrow__skeleton"></span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PositionsListSkeleton;